<template>
  <div>
    <NewNavbar variant="account" />
    <div class="flex flex-col flex-1 relative">
      <div class="account-container w-full">
        <OBackButton
          v-show="backButton.visible"
          :text="backButton.text"
          :to="backButton.to"
          @click="backButton.click ? backButton.click : () => ({})"
        />
        <main class="content">
          <nuxt />
        </main>
      </div>
    </div>
    <SupportBubble :locale="locale" />
  </div>
</template>
<script>

import { authenticated } from '@/mixins/layouts'
import { mapGetters, mapState } from 'vuex'
import { BACK_BUTTON } from '@/utils/store/getterTypes'
import NewNavbar from '@/components/NewNavbar'
import SupportBubble from '@/components/SupportBubble'
const OBackButton = () => import('@/components/OBackButton/OBackButton')

export default {
  name: 'LayoutAccountSimple',
  middleware: 'auth',
  components: {
    OBackButton,
    NewNavbar,
    SupportBubble
  },
  mixins: [authenticated],
  computed: {
    ...mapGetters('app', {
      backButton: BACK_BUTTON
    }),
    ...mapState('app', {
      locale: state => state.locale
    })
  },
  head () {
    return {
      title: 'Account'
    }
  }
}
</script>

<style lang="postcss" scoped>
  .app-container {
    @apply min-h-screen flex flex-col flex-1;

    .account-container {
      @apply mx-auto max-w-full;
      max-width: clamp(100%, 112rem, 100%);
    }
  }

  @screen md {
    .app-container {
      @apply bg-gray-100;
    }
  }
</style>
